import { login, register, logout, forgotPassword, changePassword, getDetailUser,
  acceptToc,mobileLogin,resendVerify,getCountry,connectSocial} from '@/services/auth';

export default {
  async requestAuthentication({ commit, dispatch }, user) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let response;
    try {
      response = await login(user);
      localStorage.setItem('access_token', response.data.access_token);
      localStorage.setItem('token_type', response.data.token_type);
      localStorage.setItem('expires_in', response.data.expires_in);
      commit('SET_AUTH', { accessToken: response.data.access_token, tokenType: response.data.token_type, expiresIn: response.data.expires_in });
      dispatch('requestDetailUser');
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message} : ${user.email}`, errorCode: 'ER-AUTH-02' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return response;
  },

  async requestAuthenticationSocial({ commit, dispatch }, user) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let response;
    try {
      response = await connectSocial(user);
      if(!!response.data){
        localStorage.setItem('access_token', response.data.access_token);
        localStorage.setItem('token_type', response.data.token_type);
        localStorage.setItem('expires_in', response.data.expires_in);
        commit('SET_AUTH', { accessToken: response.data.access_token, tokenType: response.data.token_type, expiresIn: response.data.expires_in });
        dispatch('requestDetailUser');
      }
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message} : ${user.email}`, errorCode: 'ER-AUTH-02' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return response;
  },

  async requestSetAuth({ commit, dispatch }, data){
    localStorage.setItem('access_token', data.access_token);
    localStorage.setItem('token_type', data.token_type);
    localStorage.setItem('expires_in', data.expires_in);
    commit('SET_AUTH', { accessToken: data.access_token, tokenType: data.token_type, expiresIn: data.expires_in });
    dispatch('requestDetailUser');
  },

  async requestMobileAuth({ commit, dispatch }, token) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let response;
    try {
      response = await mobileLogin(token);
      localStorage.setItem('access_token', response.data.access_token);
      localStorage.setItem('token_type', response.data.token_type);
      localStorage.setItem('expires_in', response.data.expires_in);
      localStorage.setItem('from_apps', true);
      commit('SET_AUTH', { accessToken: response.data.access_token, tokenType: response.data.token_type, expiresIn: response.data.expires_in });
      commit('SET_FROM_APPS', {status:true})
      dispatch('requestDetailUser');
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message} : ${user.email}`, errorCode: 'ER-AUTH-02' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return response;
  },

  async createAuthentication({ commit }, user) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let response;
    try {
      response = await register(user);
      response = {status:true,msg:''};
    } catch (err) {
      // if (err.data.message.indexOf('Duplicate entry') !== -1) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: err.data.message, errorCode: 'ER-AUTH-01' }, { root: true });
      // }
      response = {status:false,msg:err.data.message};
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return response;
  },
  async removeAuthentication({ commit }, dataAuth) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let response = true;
    try {
      // response = await logout(dataAuth.accessToken, dataAuth.tokenType);
      localStorage.removeItem('access_token');
      localStorage.removeItem('token_type');
      localStorage.removeItem('expires_in');
      localStorage.removeItem('user');
      localStorage.removeItem('from_apps');
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'ER-AUTH-03' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return response;
  },

  async requestRegister({ commit }, user) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let response = {error:false,msg:'',data:null}
    try {
      const res = await register(user);
      if(res.data!==undefined){
        response.data = res.data;
      }
      return response;
    } catch (err) {
      response.error = true;
      response.msg = err.data.message;
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'ER-AUTH-03' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return response
  },

  // eslint-disable-next-line no-unused-vars
  async requestForgotPassword({ commit }, email) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = null;
    try {
      // TODO : call service to request Forgot Password
      returnRes = await forgotPassword({ email });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'ER-AUTH-03' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },
  // eslint-disable-next-line no-unused-vars
  async requestChangePassword({ commit }, user) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      // TODO : call service to request Change password
      await changePassword(user);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'ER-AUTH-03' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },

  async requestDetailUser({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const authorization = { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] };
      const user = await getDetailUser(authorization);
      localStorage.setItem('user', JSON.stringify(user));
      commit('SET_USER', { user });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'ER-AUTH-03' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },

  async acceptToc({ commit, rootGetters }, email) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const authorization = { tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] };
      const user = await acceptToc(email, authorization);
      localStorage.setItem('user', JSON.stringify(user));
      commit('SET_USER', { user });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'ER-AUTH-03' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },

  async requestResendVerify({ commit }, email) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = null;
    try {
      // TODO : call service to request Forgot Password
      returnRes = await resendVerify({ email });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'ER-AUTH-69' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },

  async requestCountry({ commit }, email) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = [];
    try {
      // TODO : call service to request Forgot Password
      returnRes = await getCountry();
      returnRes = returnRes.data!==undefined?returnRes.data:[]
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'ER-AUTH-69' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },
  setUserSocial({ commit, rootGetters }, data){
    commit('SET_USER_SOCIAL',data);
  },
  removeUserSocial({ commit, rootGetters }){
    commit('REMOVE_USER_SOCIAL');
  },
};



// WEBPACK FOOTER //
// ./src/stores/Auth/actions/index.js